const Colors = {
  // primary: "#34f2c6", //wupo's color
  // primary: "#0F3876", //Dark blue 0F3876
  // primary: "#14549C", // Azul BBVA
  
  //dalavo iniciales
  //primary: "#00674f", // blue
  //secondary: "#00674f",
  //third: "#E2062C", // cool red
  //hover: "#021B79",

  //datalove DBC
  primary: "#4A3596", // principal purple
  secondary: "#27A2AA", //principal green
  third: "#F2736A", // cool ornage
  hover: "#F2736A",

  fourth: "#C28100", // wupo
  fifth: "#C7C4C4", // Grey
  credit: "#6DD47E", //wupo Green
  debit: "#ff003f", // wupo red
  labelColor: "#333",  // Dark grey
  button1: "#c7357c", //pink
  button2: "#6DD47E", // green
  button3: "#FFD55A" // yellow
}

/*
Dta Love Colors

#4A3596
#27A2AA
#281845
#F2736A
#E0E0E0
#1E385B
#AFAFAF

other
#4dc9f0
#f67019
#f53794
#537bc4
#acc236
#166a8f
#00a950
#58595b
#8549ba

#4dc9f0
#f67019
#f53794
#537bc4
#acc236
#166a8f
#F2736A
#4A3596
#8549ba


#FFB300
#ff6f61
#00a8e1
#d5006d
#00bfae
#8a2be2
#1338f0
#f67019
#166a8f




*/

export default Colors


